/** @jsxImportSource @emotion/react */
import { Dropdown } from "basis";
import { AccountOptionType } from "components/DirectDebit/types";
import { FC, ReactNode } from "react";
import { AccountOption } from "./AccountOption";

const accountOptionToString = (option: AccountOptionType): string =>
  option.data.cardName;

interface Props {
  name: string;
  label: string;
  hideLabel: boolean;
  accountOptions: AccountOptionType[];
  accountFooter?: ({ data }) => ReactNode;
  onChange: ({ selectedOption }) => void;
}
export const AccountsSelect: FC<Props> = ({
  name,
  label,
  hideLabel,
  accountOptions,
  accountFooter,
  onChange,
}) => {
  if (accountOptions.length === 0) {
    return null;
  }

  return (
    <Dropdown
      name={name}
      label={label}
      hideLabel={hideLabel}
      options={accountOptions}
      optionToString={accountOptionToString}
      optionComponent={(option: AccountOptionType) => (
        <AccountOption
          cardName={option.data.cardName}
          cardEndsWith={option.data.cardEndsWith}
          footer={accountFooter?.(option)}
        />
      )}
      maxHeight="400"
      onChange={onChange}
      testId="accounts-dropdown"
    />
  );
};
